import { ref } from 'vue';

// Como o status de uma obrigação é ESCRITO na tela.
//
// Victor, 10/09/2026, olhando um vencimento de 05/08 com o sistema mostrando
// "Vencida": "olha a data do vencimento e olha a data de hoje, é mais que D+7
// né? e não apareceu como inadimplente".
//
// Ele está certo, e a regra é do escritório: passado o D+7 a régua de
// cobrança para de avisar e o cliente vira INADIMPLENTE
// (`FinancialDunningJob::MAX_OFFSET`). Antes disso ele só está VENCIDO — a
// régua ainda está falando com ele.
//
// 🔴 ISTO É RÓTULO, NÃO ESTADO NOVO NO BANCO.
//
// O banco continua com `overdue` e uma data de vencimento; "inadimplente" é
// os dois lidos juntos. Criar um sexto status no enum obrigaria alguém a
// virar a chave todo dia à meia-noite, e uma obrigação passaria a poder ficar
// PARADA no estado errado. Data não erra.
//
// `dunning_status` não serve para isto: ele só é preenchido quando a régua
// roda, e a régua está DESLIGADA nesta conta — todas as obrigações estariam
// em `none` para sempre.

// Espelhava `FinancialDunningJob::MAX_OFFSET`. Virou configuração do
// escritório (`Financial::DunningSetting#dias_ate_inadimplente`, 10 na
// produção) e a régua da Cobrança já lia de lá — a lista não: a parcela com
// 8 a 10 dias de atraso era "Inadimplente" na lista e "Vencida" na Cobrança
// (03/10/2026). Agora a tela recebe o número do servidor
// (`definirDiasAteInadimplente`); o 7 fica só até ele chegar.
export const DIAS_ATE_INADIMPLENTE = 7;
// `ref`: a lista pode desenhar antes do número chegar, e redesenha quando ele
// chega.
const diasAteInadimplente = ref(DIAS_ATE_INADIMPLENTE);

export const definirDiasAteInadimplente = dias => {
  const n = Number(dias);
  diasAteInadimplente.value =
    Number.isInteger(n) && n > 0 ? n : DIAS_ATE_INADIMPLENTE;
};

const emDias = data => {
  if (!data) return null;
  // `2026-08-05` vira meia-noite LOCAL, não UTC: com `new Date('2026-08-05')`
  // o navegador em -03 volta um dia e o cálculo erra na virada.
  const [ano, mes, dia] = String(data).slice(0, 10).split('-').map(Number);
  if (!ano || !mes || !dia) return null;
  return new Date(ano, mes - 1, dia);
};

/**
 * Devolve a CHAVE do rótulo a mostrar para uma obrigação.
 *
 * @param {object} params
 * @param {string} params.status    status do banco
 * @param {string} params.dueDate   vencimento (YYYY-MM-DD)
 * @param {Date}   [params.hoje]    injetável para teste
 * @returns {string} chave de tradução em FINANCIAL_MODULE.STATUS
 */
export const chaveDoStatus = ({ status, dueDate, hoje = new Date() }) => {
  if (status !== 'overdue') return status;

  const venceu = emDias(dueDate);
  if (!venceu) return 'overdue';

  const limite = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  limite.setDate(limite.getDate() - diasAteInadimplente.value);

  return venceu < limite ? 'inadimplente' : 'overdue';
};

/**
 * Mesma regra, para quem ainda não salvou: a tela do formulário precisa
 * responder "como vai ficar salvo" antes de existir registro.
 *
 * @returns {string} 'settled' | 'inadimplente' | 'overdue' | 'pending'
 */
export const chaveDoStatusPrevisto = ({ pago, dueDate, hoje = new Date() }) => {
  if (pago) return 'settled';

  const venceu = emDias(dueDate);
  const hojeZerado = new Date(
    hoje.getFullYear(),
    hoje.getMonth(),
    hoje.getDate()
  );
  if (!venceu || venceu >= hojeZerado) return 'pending';

  return chaveDoStatus({ status: 'overdue', dueDate, hoje });
};
